document.addEventListener("DOMContentLoaded", () => {
  // if (window.Rebuy && window.Rebuy.SmartCart) {}
  document.addEventListener("rebuy:cart.add", (event) => {
    if (!atcPopupMobileAndDesktop) {
      // Mobile only: check window size
      let windowWidth = window.innerWidth;
      if (windowWidth <= 768) {
        Rebuy.SmartCart.skip_open = true;
      } else {
        Rebuy.SmartCart.skip_open = false;
      }
      window.addEventListener("resize", () => {
        windowWidth = window.innerWidth;
        if (windowWidth <= 768) {
          Rebuy.SmartCart.skip_open = true;
        } else {
          Rebuy.SmartCart.skip_open = false;
        }
      });
      setTimeout(() => {
        if (windowWidth <= 768) {
          window.Rebuy.SmartCart.hide();
          const cart = event.detail;
          updatePopUp(cart);
        }
        document.querySelectorAll(".cart_count_item").forEach((item) => {
          item.innerText = Rebuy.Cart.itemCount();
        });
      }, 1000);
    } else {
      // Desktop and mobile
      Rebuy.SmartCart.skip_open = true;
      setTimeout(() => {
        window.Rebuy.SmartCart.hide();
        const cart = event.detail;
        updatePopUp(cart);

        document.querySelectorAll(".cart_count_item").forEach((item) => {
          item.innerText = Rebuy.Cart.itemCount();
        });
      }, 1000);
    }
  });
});

function updatePopUp(cart) {
  const product = cart.item;
  const productImage = product.image;
  const productTitle = product.product_title;
  const productPrice = product.price;
  const productVariant = product.variant_options;
  const cartTotal = Rebuy.Cart.subtotal();
  // Currency Conversion
  let threshold = 15000;
  if (Shopify.currency.active === "USD") {
    // threshold = threshold;
  } else {
    threshold = threshold * Shopify.currency.rate;
  }
  const percentage = (cartTotal / threshold) * 100;

  const popUp = document.querySelector("#custom-atc-popup");

  // Cleanse data before adding to pop up
  popUp.querySelector("#product-title-price #title").innerText = "";
  popUp.querySelector("#product-title-price #price").innerText = "";
  popUp.querySelector("#attributes").innerHTML = "";

  // Added Product Data
  popUp.querySelector("#product-image img").src = productImage;
  popUp.querySelector("#product-image img").title = productTitle;
  popUp.querySelector("#product-title-price #title").innerText = productTitle;
  popUp.querySelector("#product-title-price #price").innerText =
    formatMoney(productPrice);
    
  let variantContainer = document.createElement("div");
  variantContainer.classList.add("variant-container");
  productVariant.forEach((variant) => {
    let div = document.createElement("div");
    div.classList.add("variant");
    div.innerText = variant;
    variantContainer.appendChild(div);
  });
  popUp.querySelector("#attributes").append(variantContainer);

  // Shipping Threshold Data
  popUp.querySelector("#shipping-threshold #percentage").style.width =
    percentage.toFixed(0) + "%";
  popUp
    .querySelector("#shipping-threshold #percentage")
    .setAttribute("data-percentage", percentage.toFixed(0));
  if (cartTotal >= threshold) {
    popUp.querySelector("#shipping-threshold-message").innerText =
      "You've reached free shipping!";
  } else {
    let currency = Shopify.currency.active;
    popUp.querySelector("#shipping-threshold-message").innerText =
      `You\'re spending ${formatMoney(threshold - cartTotal)}${Shopify.currency.active == "USD" ? "" : " " + currency} away from free shipping!`;
  }
  // console.log('Alex: popUp', popUp);
  if (Shopify.customerPrivacy.getRegion().includes("US")) {
    popUp.querySelector("#shipping-threshold").style.display = "block";
    console.log("Alex: US ", Shopify.customerPrivacy.getRegion());
  }

  popUp.style.display = "block";

  setTimeout(() => {
    popUp.classList.add("show");
    popUp.style.opacity = 1;
  }, 100);

  setTimeout(() => {
    popUp.style.opacity = 0;
    popUp.classList.remove("show");
    setTimeout(() => {
      popUp.style.display = "none";
    }, 1300);
  }, 3000);
}

    function formatMoney(cents) {
        if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
            const moneyFormat = window.Shopify.money_format || window.Shopify.moneyFormat;
            if (moneyFormat) return window.Shopify.formatMoney(cents, moneyFormat);
        }
        return '$' + ((Number(cents) || 0) / 100).toFixed(2);
    }